import React from "react";
import { useTranslation } from "react-i18next";
import "../states.css";

const BusinessLoadingState = () => {
  const { t } = useTranslation("common");

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="ui-state-surface flex min-h-[400px] items-center justify-center"
    >
      <div className="mx-auto max-w-md p-6 text-center">
        <div className="ui-state-icon-surface mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-[var(--od-radius-panel)]">
          <div
            aria-hidden="true"
            className="ui-state-spinner ui-state-motion h-8 w-8 animate-spin rounded-full border-2"
          ></div>
        </div>

        <h3 className="mb-2 text-lg font-semibold">
          {t("states.loadingBusinesses")}
        </h3>

        <p className="ui-state-muted">
          Please wait while we load your business information...
        </p>
      </div>
    </div>
  );
};

export default BusinessLoadingState;
